import api from "../../utils/axios-util";
import Middleware from "../../utils/api-middleware"
const trigger_by = process.env.REACT_APP_TRIGGER_BY


export const CustomformData = (payload) => {
    let isClosed = ''
    if(payload.isclosed !== undefined ){
        isClosed = `&isClosed=${payload.isclosed}`
    }
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/records?phone_number=${payload.phone_number}&template_name=${payload.template_name}&id=${payload.id}${isClosed}`)
                .then((response) => {
                    let res= Middleware("custom  fields","fetch",response)
                    
                    if (res.statusCode == 200) {
                        dispatch({
                            type: 'CUSTOM_DATA',
                            payload: res.data[0].others
                        })

                        dispatch({
                            type: 'CUSTOM_SIDEBARINFO',
                            payload: true
                        })
                    } else if (res.statusCode == 204) {
                        dispatch({
                            type: 'CUSTOM_SIDEBARINFO',
                            payload: false
                        })
                    }

                    resolve(res);
                })
                .catch((err) => {
                    let res= Middleware("custom fields","fetch",err.response.data,"catch")
                    reject(res);
                });
        });
    };
};


export const CustomformFields = (template_name) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/aster/form/template/fields?template_name=${template_name}`)
                .then((response) => {
                    let res= Middleware("custom  fields","fetch",response)
                    if(res.statusCode===200){
                        dispatch({
                            type: 'CUSTOM_FIELDS',
                            payload: response.data[0]
                        })
                        resolve(res);
                    }
                    
                })
                .catch((err) => {
                    let res= Middleware("custom fields","fetch",err.response.data,"catch")
                    reject(res);
                });
        });
    };
};

export const CustomformUpdate = (data, tempdetail) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            data.trigger_by = trigger_by
            await api
                .put(`/aster/form/${tempdetail.template_name}/${tempdetail.id}`, data)
                .then((response) => {
                    let res= Middleware("leads","update",response)
                    // localStorage.removeItem('wa-session-data')
                    dispatch({
                        type: 'CUSTOM_UPDATE',
                        payload: data
                    })
                    resolve(res);
                })
                .catch((err) => {
                    let res= Middleware("leads","update",err.response.data,"catch")
                    reject(res);
                });
        });
    };
};

export const CustomFormCreate = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            payload.trigger_by = trigger_by
            await api
                .post(`/aster/form`, payload)
                .then((response) => {
                    let res= Middleware("leads","create",response)
                    dispatch({
                        type: 'SET_SAVING',
                        saving: false
                    });
                    // localStorage.removeItem('wa-session-data')

                    resolve(res);
                })
                .catch((err) => {
                    let res= Middleware("leads","create",err.response.data,"catch")
                    reject(res);
                });
        });
    };
};

export const ModuleCustomformFields = (template_name) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/formbuilder/aster/form/template/fields?template_name=${template_name}`)
                .then((response) => {
                    let res= Middleware("custom module fields","fetch",response)
                    if(res.statusCode===200){
                        dispatch({
                            type: 'CUSTOM_FIELDS',
                            payload: res.data[0]
                        })
                    }
                    resolve(res);
                   
                })
                .catch((err) => {
                    let res= Middleware("custom module fields","fetch",err.response.data,"catch")
                              reject(res);
                });
        });
    };
};
export const CustommoduleFetch = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/getAssignedModule?template_name=${payload.template_name}&module=${payload.module}`)
                .then((response) => {
                    let res= Middleware("custom module","fetch",response)
                    resolve(res);
                })
                .catch((err) => {
                    let res= Middleware("custom module","fetch",err.response.data,"catch")
                              reject(res);
                });
        });
    };
};


export const PopupRouter = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/popup?phone_number=${payload.phone_number}&module=${payload.module}&template_name=${payload.template_name}&user=${localStorage.getItem('user')}&lead_id=${payload.lead_id}`)
                .then((response) => {
                    let res= Middleware("PopupRouter","fetch",response)
                              resolve(res);
                })
                .catch((err) => {
                    let res= Middleware("PopupRouter","fetch",err.response.data,"catch")
                              reject(res);
                });
        });
    };
};
export const GetChannel = () => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/channel/fetch?active=0`)
                .then((response) => {
                     let res= Middleware("channel","fetch",response)
                              resolve(res);
                })
                .catch((err) => {
                    let res= Middleware("channel","fetch",err.response.data,"catch")
                              reject(res);
                });
        });
    };
};


